import { useMutation } from '@tanstack/react-query';
import { generateIncomeStatement } from '../requests';
import type { Language } from '@/shared/types';

export function useGenerateIncomeStatement() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (lang: Language) => generateIncomeStatement(lang),
  });

  return {
    generateIncomeStatement: mutateAsync,
    isPending,
  };
}
